import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {ContactMessage, UserAccount} from '../__generated__/resolvers-types';

export const LIST_CONTACT_MESSAGES_QUERY = gql`
  query ListContactMessages($offset: Float, $limit: Float) {
    listContactMessages(offset: $offset, limit: $limit) {
      id
      name
      email
      category
      message
      createdAt
      attachments {
        name
        type
        data
      }
    }
  }
`;

export const LIST_ALL_CONTACT_MESSAGES_QUERY = gql`
  query ListAllContactMessages($offset: Float, $limit: Float) {
    listAllContactMessages(offset: $offset, limit: $limit) {
      id
      name
      email
      category
      message
      createdAt
      attachments {
        name
        type
        data
      }
    }
  }
`;

export interface ListContactMessagesParams {
  offset?: number;
  limit?: number;
  user?: UserAccount | null;
}

export function useListContactMessages(params?: ListContactMessagesParams) {
  const isOwner = params?.user?.permissions?.includes('owner') || false;

  const regularQuery = useQuery<{listContactMessages: ContactMessage[]}>(LIST_CONTACT_MESSAGES_QUERY, {
    variables: params,
    fetchPolicy: 'network-only',
    skip: isOwner,
  });

  const ownerQuery = useQuery<{listAllContactMessages: ContactMessage[]}>(LIST_ALL_CONTACT_MESSAGES_QUERY, {
    variables: params,
    fetchPolicy: 'network-only',
    skip: !isOwner,
  });

  // Return the appropriate query result based on user permissions
  if (isOwner) {
    return {
      data: ownerQuery.data ? {listContactMessages: ownerQuery.data.listAllContactMessages} : undefined,
      loading: ownerQuery.loading,
      error: ownerQuery.error,
    };
  }

  return regularQuery;
}
